"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandFingerprintsToJSON = exports.HandFingerprintsFromJSONTyped = exports.HandFingerprintsFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function HandFingerprintsFromJSON(json) {
    return HandFingerprintsFromJSONTyped(json, false);
}
exports.HandFingerprintsFromJSON = HandFingerprintsFromJSON;
function HandFingerprintsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fingers': !runtime_1.exists(json, 'fingers') ? undefined : _1.FingerprintsFromJSON(json['fingers']),
    };
}
exports.HandFingerprintsFromJSONTyped = HandFingerprintsFromJSONTyped;
function HandFingerprintsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fingers': _1.FingerprintsToJSON(value.fingers),
    };
}
exports.HandFingerprintsToJSON = HandFingerprintsToJSON;
//# sourceMappingURL=HandFingerprints.js.map